import { render } from "./SmoothScroll.vue?vue&type=template&id=7d871567&ts=true"
import script from "./SmoothScroll.vue?vue&type=script&lang=ts"
export * from "./SmoothScroll.vue?vue&type=script&lang=ts"

import "./SmoothScroll.vue?vue&type=style&index=0&id=7d871567&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__